const JsMobileMenu = {
  init () {

    /*              __
                   / _)         
            .-^^^-/ /          
        __/       /              
        <__.|_|-|_|  

        The Emagine Dinosaur says; "Our approved designs call for the back button to be utilise the same name as their parent.".          
    */

    if ( $('.c-mobile-menu').length ) {
      $('.back-link').each(function(){
        var backTxt = $(this).parent().closest('.is-drilldown-submenu-parent').find('> a').text();
        $(this).text(backTxt);
      });
    }
  }
};

export default JsMobileMenu;


// WEBPACK FOOTER //
// ./src/js/modules/mobile-menu.js